import http from "../../utils/httpClient";

class adminDashboardService {
  // Get All Summaries Dashboard Data Service Start
  getAllSummariesDashboardData = async (query) => {
    return await http.get(`/api/Dashboard/GetAllSummaries`, { params: query });
  };
  // Get All Summaries Dashboard Data Service End
}

export default new adminDashboardService();
